export default {
    //核心框架的版本
    version: "2.1.0",

    webRoot: {
        //此项目的文件夹名称，平台的配置，项目组请勿修改
        idm:"idm",
        //框架的所属项目的根目录名称，
        default: "/DreamWeb/",
        //页面的前置路径，可相对或绝对（./或../idm/或/DreamWeb/idm/）
        htmlDir: "./",
        //打包编译的静态资源文件，相对于当前的页面路径
        assetsDir: "./static/",
        /**
         * 组件相对此框架所在项目的目录(以idm_modules放在程序根目录为举例)
         * 框架页面index.html在DreamWeb/idm/A  下面，则为../../idm_modules/或/DreamWeb/idm_modules/
         * 框架页面index.html在DreamWeb/ 下面，则为./idm_modules/或/DreamWeb/idm_modules/
         */
        moduleDir: "./idm_modules/",
        /**
         * 平台的编号，此项相当于一个产品的基本编号，所有编译后的程序应该放到这个编号下面
         * DreamWeb的默认为p1000,项目组请勿修改，否则造成程序无法访问
         * 如无编号可留空
         */
        platformNo:"p1000",
        /**
         * 项目的编号，此项相当于一个项目的扩展编号，所有上传的文件都会和配置的文件都会保存在此编号的文件夹下面
         * 如果与platformNo为相同编号则默认为都是平台的
         * 如无编号可留空
         */
        projectNo:"p1000",
        /**
         * 组件的存放路径，相对于程序根目录的绝对的路径
         */
        moduleAbsoluteDir:"/{projectNo}/idm/idm_modules/"
    },
    //页面结构（页面设置数据）
    pageSchema: {
        //保存方式，支持磁盘存储JSON格式（disk）和数据库存储（database）
        saveType: "database",
        //磁盘存储json格式的相对路径地址（支持{version}和{pageid}替换）
        jsonDir: "/{projectNo}/idm/idm_pageschema/{pageid}/{version}.json"
    },
    // api地址，以下属性为空则会使用mockdata对应下面的数据源
    api: {
        /**
         * 组件市场接口地址，带分组结构的（/ctrl/idm/api/fetchComponentMarketData）
         * 无参数
         */
        componentMarketUrl: "",
        /**
         * 业务组件接口地址，带分组结构的（/ctrl/idm/api/fetchComponentCustomData）
         * 无参数
         */
        componentCustomUrl: "",
        /**
         * 页面的版本接口地址（/ctrl/idm/api/fetchPageVersionList)
         * 接收以下参数：
         * pageid：页面ID
         */
        pageVersionListUrl: "/ctrl/idm/api/fetchPageVersionList",
        /**
         * 页面的配置数据地址（/ctrl/idm/api/fetchPageSettingData)
         * 接收以下参数：
         * pageid：页面ID
         * version：页面版本号（如果版本号为空则需要返回最新的版本号的数据，不管saveType为disk还是database都是如此）
         * savetype:当前配置的存储方式==》磁盘存储JSON格式（disk）和数据库存储（database）
         * projectNo：项目编号
         * schemaType：0：布局组件，1：业务组件
         * urlData:当前浏览器地址的所有参数json字符串格式，预览模式下也有可能会通过此处传schemaType参数
         */
        pageSettingDataUrl: "/ctrl/idm/api/fetchPageSettingData",
        /**
         * 自定义业务（布局）组件的配置数据地址（/ctrl/idm/api/fetchCustomModuleSettingData)
         * 接收以下参数：
         * pageid：页面ID
         * schemaType：0：布局组件，1：业务组件
         */
         customModuleSettingDataUrl: "/ctrl/idm/api/fetchCustomModuleSettingData",
        /**
         * 保存页面配置接口地址(/ctrl/idm/api/savePageSchema)
         * 接收以下参数：
         * pageid：页面ID
         * pageSettingData：页面结构数据json字符串，保存到数据库或json文件即可
         * version：版本号
         * author：作者
         * remark：备注
         * isUse：是否将此版本设为使用版本，1代表使用，0代表不使用
         * traceList：历史记录操作数据,格式：[{actionType:动作类型、pageid：页面ID、pageVersion：页面版本、opDate：操作日期、opTime：操作时间、opContent：操作记录内容对象}]
         * projectNo：项目编号
         */
        savePageSettingUrl: "/ctrl/idm/api/savePageSchema",
        /**
         * 保存自定义组件配置接口地址(/ctrl/idm/api/saveCustomModule)
         * 接收以下参数：
         * pageid：组件ID
         * title：页面标题
         * previewImgJson：预览的图片JSON
         * moduleType：组件类型：0：布局组件，1：业务组件
         * moduleIconfont：组件图标
         * moduleContainerCount：布局组件的容器数量
         * pageSettingData：组件结构数据json字符串，保存到数据库即可
         * author：作者
         * remark：备注
         * traceList：历史记录操作数据,格式：[{actionType:动作类型、pageid：页面ID、pageVersion：页面版本、opDate：操作日期、opTime：操作时间、opContent：操作记录内容对象}]
         * projectNo：项目编号
         */
        saveCustomModuleUrl:"/ctrl/idm/api/saveCustomModule",
        /**
         * 上传图片、文件的接口地址（主要用于框架、公共上传方法）
         * 接收以下参数：
         * type：dev_uploadimage_ctrl
         * getFileContent:1 为1代表返回上传文件的内容
         * file：文件（java使用【((MultipartHttpServletRequest)HttpServletRequest).getFile("file")】获取）
         * ...IDM.setting.webRoot
         * 返回结果示例：
         * {
         *  fileName: "tab设置.png"
         *  filePath: "/upload/idmfiles/f22081da-9410-40bc-afa0-6b3106c45c1c.png"
         *  fileSize: "218KB"
         * }
         */
        uploadFileServerUrl: "/ctrl/idm/api/fileupload",
        /**
         * 保存裁剪后的图片base64转存为图片文件
         * 接收以下参数：
         * type：dev_uploadimage_ctrl
         * data：图片base64
         * suffix:后缀名 jpeg, png, webp
         * ...IDM.setting.webRoot
         * 返回结果示例：
         * {
         *  fileName: "tab设置.png"
         *  filePath: "/upload/idmfiles/f22081da-9410-40bc-afa0-6b3106c45c1c.png"
         *  fileSize: "218KB"
         * }
         */
        saveCropperBase64ImageUrl:"/ctrl/idm/api/saveBase64ToImageFile",
        /**
         * 开发环境的获取操作痕迹的列表记录
         * 接收以下参数：
         * pageid：页面ID
         * startIndex：开始索引
         * pageNumber：每页显示大小
         * 返回结果示例：
         * [{
         *  id:数据ID，没有实际意义，只有有删除功能才有意义
         *  actionType: 动作类型数字
         *  pageId:页面ID
         *  pageVersion:页面版本
         *  opDate:操作日期
         *  opTime:操作时间
         *  opContent:操作实际内容
         * }]
         */
        developTraceListUrl:"/ctrl/idm/api/fetchDevelopTraceListInfo",
        /**
         * 获取应用信息的接口地址
         * 接收以下参数：
         * urlData:url地址中的全部参数地址,
         * pageid：页面ID
         * 返回结果内容不固定
         */
        applicationInfoUrl:"/ctrl/idm/api/fetchApplicationInfo",
        /**
         * 获取当前登录用户信息的接口地址
         * 接收以下参数：
         * urlData:url地址中的全部参数地址,
         * pageid：页面ID
         * 返回结果内容不固定
         */
        userInfoUrl:"/ctrl/idm/api/fetchUserInfo",
        /**
         * 页面个性化保存的接口地址
         * 接收以下参数：
         * urlData:url地址中的全部参数地址,
         * pageid：页面ID
         * version：页面版本号
         * customData：个性化定制的数据，结构为对象，对象下包含数组层级的
         * reset:为1则代表重置操作
         * 
         * 返回结果示例(使用统一结构，data返回为null即可)：
         */
        saveUserCustomizationUrl:"/ctrl/idm/api/saveUserCustomization",
         /**
          * 页面个性化获取的接口地址
          * 接收以下参数：
          * urlData:url地址中的全部参数地址,
          * pageid：页面ID
          * version：页面版本号，如果没有传则会直接取用户最新设置的一条
          * 
          * 返回结果示例：
          * {
          *    "code":"200",
          *    "message":"",
          *    "data":{
          *      id:"",
          *      idmId:"",
          *      pageId:"",
          *      pageVersion:"",
          *      customData:"此处为用户个性化定制后的数据，为保存的时候传的customData,如果发现此处data为null则使用/ctrl/idm/api/fetchPageSettingData接口",
          *      userId:"",
          *    }
          * }
          */
        userCustomizationUrl:"/ctrl/idm/api/fetchUserCustomization",
        /**
         * 表单提交元数据的URl地址，用户可以自定义
         * 接收以下参数：
         * urlData:url地址中的全部参数地址,
         * pageId：页面ID,
         * moduleData:表单的所有数据
          * 返回结果示例：
          * {
          *    
          * }
         */
        saveFormsMetaDataUrl:"/ctrl/idm/api/saveFormsMetaData",
        /**
         * 文档管理的代码包数据url地址（/ctrl/idm/console/fetchAllCodePackageList）
         * 返回结果示例：
         * {
         * }
         */
        allCodepackageUrl:"/ctrl/idm/console/fetchAllCodePackageList",
        /**
         * 获取组件控制中心（动态属性）设置的数据的url地址（/ctrl/idm/console/fetchMarketModuleAttrUserSetData）
         * 返回结果示例：
         * [{
         * id:"",
         * attrCode:"",
         * attrData:"",
         * ...
         * }]
         */
        dynamicAttributeListUrl:"/ctrl/idm/console/fetchMarketModuleAttrUserSetData",
        /**
         * 页面列表查询Api地址
         * 请求参数：
         * {
         * pageIndex:页码
         * pageSize:页大小
         * searchText:文本框检索条件
         * pagetype:页面类型检索条件
         * group:页面分组检索条件
         * sort:页面排序检索条件
         * }
         * 返回结果：
         * {
         *    "code":"200",
         *    "message":"",
         *    "data":[
         *        {
         *           id: "idm_control_setting_panel_001",
         *           title: "IDM控制中心-组件设置界面",
         *           moduleGroupId: "idmkztpage",
         *           moduleGroupText: "IDM控制台页面",
         *           pageType: "0",
         *           pageRemark: "IDM控制中心-组件设置界面，主要用于所有组件的设置渲染界面，用于普通用户能定制每个组件的效果",
         *           previewImgJson: "[{\"uid\":\"1642733481374xiV1BZAGIMlDEfym\",\"ourl\":\"/p1000/idm/upload/idmfiles/6aaf99da-2053-4684-b80a-642328750d36.jpg\",\"size\":\"90KB\",\"src\":\"/p1000/idm/upload/idmfiles/6aaf99da-2053-4684-b80a-642328750d36.jpg\",\"name\":\"Dingtalk_20220121105100.jpg\",\"width\":1920,\"url\":\"/DreamWeb/p1000/idm/upload/idmfiles/6aaf99da-2053-4684-b80a-642328750d36.jpg\",\"status\":\"done\",\"height\":937}]"
         *        },
         *        ...
         *     ]
         * }
         */
        pageSelectFetchPageListApi:"/ctrl/idm/console/fetchIdmListPageData",
        /**
         * 数据源列表查询Api地址
         * 请求参数：
         * {
         * pageIndex:页码
         * pageSize:页大小
         * searchText:文本框检索条件
         * type:数据源类型检索条件
         * group:数据源分组检索条件
         * moduleList:适配组件检索条件
         * productList:产品标签检索条件
         * dataSourceId:"指定要获取数据源的ID"
         * codeId:"所属目录ID"
         * }
         * 返回结果：
         * {
         *    "code":"200",
         *    "message":"",
         *    "data":{
                "total": 2,
                "rows": [
         *        {
         *           id: "数据源id",
         *           title: "数据源名称",
         *           groupId: "分组ID",
         *           groupName: "分组名称",
         *           tag: "[],{},[{}],title,data,",
         *           itemIndex: "排序",
         *           remark: "描述",
         *           ...
         *        },
         *        ...
         *      ]
         *    }
         * }
         */
        dataSourceFetchListApi:"/ctrl/idm/api/dataSourceFetchListApi",
        /**
         * 数据源表单保存Api地址
         * 提交请求类型:
         * "Content-Type": "application/json;charset=UTF-8"
         * 提交参数：
         * {
         *      "id": "为空则是新增",
                "type": "1",
                "shareType": "1",
                "loadType": "0",
                "dbName":"数据库连接名称",
                "dbSql": "SELECT ",
                "resultJson": "{\"data\":\"响应数据\"}"
                "functionParam": "function (options) {\n    return options;\n}",
                "functionResult": "function (res) {\n    return res.data;\n}",
                "functionError": "function (err) {\n\n}",
                "editDebugData":"是否只修改调试数据",
                "title": "数据源demo1",
                "author": "申龙",
                "remark": "数据源备注数据源备注数据源备注",
                "datamodelId":"数据模型ID",
                "datamodelName":"数据模型名称",
                "groupId": "-1",
                "moduleArray":[{key: "1", label: " 组件示例 "}],
                "tags": "[],{}",
                "itemIndex": 1,
                "api": "http://www.yunit.cn/api",
                "requestType": "GET",
                "timeout": 0,
                "crossOrigin": true,
                "debugResult":"数据源调试后的结果",
                "paramJson": "[{\"name\":\"1\",\"valueType\":1,\"value\":true},{\"name\":\"1\",\"valueType\":0,\"value\":\"3\"}]",
                "headerJson": "[{\"name\":\"3\",\"valueType\":0,\"value\":\"5\"},{\"name\":\"4\",\"valueType\":0,\"value\":\"6\"}]",
                "refreshJson":"[{\"key\":\"inbox\",\"desc\":\"备注\"},{\"key\":\"inbox\",\"desc\":\"备注\"}]",
                "file_name":[
                    {
                        "uid": "1664508531878n0cxJmm9BxU83p1H",
                        "name": "1.txt",
                        "status": "done",
                        "url": "/DreamWeb/p1000/idm/upload/idmfiles/1a618495-93e3-4e80-b16c-6e18048e4177.txt",
                        "ourl": "/p1000/idm/upload/idmfiles/1a618495-93e3-4e80-b16c-6e18048e4177.txt",
                        "src": "/p1000/idm/upload/idmfiles/1a618495-93e3-4e80-b16c-6e18048e4177.txt",
                        "size": "7KB"
                    }
                ]
           }
         */
        dataSourceSaveFormApi:"/ctrl/idm/api/saveDataSource",
        /**
         * 数据源删除Api地址
         * 提交参数：
         * {
         *      id:"数据源主键"
         * }
         * 返回结果示例(使用统一结构，data返回为null即可)：
         */
        dataSourceDeleteApi:"/ctrl/idm/api/delDataSource",
        /**
         * 数据源复制Api地址
         * 提交参数：
         * {
         *      id:"数据源主键"
         * }
         * 返回结果示例(使用统一结构，data返回为null即可)：
         */
        dataSourceCopyApi:"/ctrl/idm/api/copyDataSource",
        /**
         * 后端转发请求数据源
         * 提交请求类型:
         * "Content-Type": "application/json;charset=UTF-8"
         * 提交参数：
         * {
         *   paramJSON:替换后的参数对象,
         *   headerJSON:替换后的请求头,
         *   dataSourceData:{
         *      api,
         *      requestType,
         *      timeout,
         *      crossOrigin,
         *      ...
         *   }
         * }
         */
        dataSourceForwardApi:"/ctrl/customPortal/dataSource/getDatas",
        /**
         * 数据源数据库sql执行api
         * 
         * 提交请求类型:
         * "Content-Type": "application/json;charset=UTF-8"
         * 提交参数：
         * {
         *  dataSourceId:"数据源主键",
         *  paramInfo:调用直接传递的参数,
         *  sqlParam:sql语句所需要的参数
         * }
         */
        dataSourceDbSqlApi:"/ctrl/idm/api/executeSql",
        /**
         * 数据模型数据获取Api
         * 提交参数：
         * {
         *      id:"数据模型主键"
         * }
         */
         dataModelGetDataApi:"/ctrl/idm/datamodel/get",
        /**
         * 数据模型列表查询Api地址
         * 请求参数：
         * {
         * pageIndex:页码
         * pageSize:页大小
         * searchText:文本框检索条件
         * TYPE:数据模型类型检索条件
         * GROUP_ID:数据模型分组检索条件
         * }
         * 返回结果：
         * {
         *    "code":"200",
         *    "message":"",
         *    "data":{
                "total": 2,
                "rows": [
         *        {
         *           id: "数据模型id",
         *           title: "数据源名称",
         *           groupId: "分组ID",
         *           itemIndex: "排序",
         *           remark: "描述",
         *           ...
         *        },
         *        ...
         *       ]
         *    }
         * }
         */
        dataModelFetchListApi:"/ctrl/idm/datamodel/getList",
    },
    /**
     * mockdata地址，只有对应的API地址为空的时候才会使用这里的数据
     * 前缀$代表：使用webRoot > assetsDir替换
     * 前缀~代表：使用webRoot > htmlDir替换
     * 前缀@代表：使用webRoot > moduleDir替换
     * 前缀./或../或http://或https://则不替换，原模原样使用地址
     * 其他情况使用webRoot > default替换
     */
    mockurl: {
        /**
         * 组件市场测试数据结构
         */
        componentMarketUrl: "$/mockdata/ComponentMarketData.json",
        /**
         * 业务组件接口地址
         */
        componentCustomUrl: "$/mockdata/ComponentCustomData.json",
        /**
         * 页面的版本测试数据结构
         */
        pageVersionListUrl: "$/mockdata/PageVersionListData.json",
        /**
         * 页面的配置数据的数据结构
         */
        pageSettingDataUrl: "$/mockdata/pageSettingDataData.json",
        /**
         * 自定义业务（布局）组件的配置数据结构
         */
         customModuleSettingDataUrl: "$/mockdata/customModuleSettingDataData.json",
         /**
          * 文档管理的代码包数据结构
          */
         allCodepackageUrl:"$/mockdata/AllCodePackageListData.json"
    },
    //页面配置工具
    develop: {
        /**
         * 开发工具菜单栏中的IDM学院地址，可以是相对路径，也可以是绝对路径
         * 前缀$代表：使用webRoot > assetsDir替换
         * 前缀~代表：使用webRoot > htmlDir替换
         * 前缀@代表：使用webRoot > moduleDir替换
         * 前缀./或../或http://或https://则不替换，原模原样使用地址
         * 其他情况使用webRoot > default替换
         */
        schoolsUrl: "http://school.yunit.cn",
        /**
         * 开发工具菜单栏中的组件开发地址，前缀同理上面
         */
        devComponentUrl: "https://yunit-code.github.io/zh/moduledevelop/introduce.html",
        /**
         * 开发工具菜单栏中的帮助文档地址，前缀同理上面
         */
        helpDocumentUrl: "https://yunit-code.github.io/zh/",
        /**
         * 开发工具菜单栏中文档管理地址，前缀同理上面
         */
         documentManageUrl: "./index.html#/document",
        /**
         * 拖拽区域的大小列表配置
         * {
                key: 从3开始，保证不重复即可,
                width: 拖拽区域的实际宽度（px）,
                height: 拖拽区域的实际高度（px）,
                showText: 要显示的文本,
                type: 类型值
            }
         * type:-1 线条
         * type:3  系统内置的尺寸
         */
        dragAreaSizeList: [
            {
                key: '3',
                width: 1366,
                height: 768,
                showText: '1366*768',
                type: 3
            },
            {
                key: '4',
                width: 1920,
                height: 1080,
                showText: '1920*1080',
                type: 3
            },
            {
                key: '5',
                width: 375,
                height: 667,
                showText: 'iphone6/7/8',
                type: 3
            },
            {
                key: '6',
                width: 414,
                height: 736,
                showText: 'iphone6/7/8 Plus',
                type: 3
            },
            {
                key: '7',
                width: 768,
                height: 1024,
                showText: 'iPad(768*1024)',
                type: 3
            },
            {
                key: '8',
                width: 1024,
                height: 768,
                showText: 'iPad(1024*768)',
                type: 3
            }
        ],
        /**
         * 拖拽区域大小默认值key，url中传入dragSizeKey也会有效
         * 默认为1：代表适应当前尺寸
         */
        dragAreaSizeDefaultKey:"1",
        /**
         * 组件市场的列表默认显示类型
         * grid：网格类型
         * list：列表类型
         * rectangle：矩阵类型
         */
        componentMarketListDefaultType:"rectangle",
        /**
         * 开启开发工具中获取用户信息，注意：只会使用配置项中（userInfoUrl）的接口进行加载，页面属性设置中的无法进行加载。
         */
        openFetchUserInfo:true,
        /**
         * 开启开发工具中工作区的放大缩小功能
         */
        scaleOpen:true,
        /**
         * 配置开发工具中工作区的放大缩小比例列表
         */
        scaleList:[25,50,75,100,125,150,200,300,400,600,800,1000],
        /**
         * 配置开发工具中组件属性控件（页面选择：pageSelect）页面类型的检索条件
         * 如果为数组格式则是属于静态数据，格式：[{text:"PC",value:"0"},...]
         * 为字符串格式则视为通过接口获取，返回格式为：
         * 返回结果示例：
         * {
         *    "code":"200",
         *    "message":"",
         *    "data":[{text:"PC",value:"0"},...]
         * }
         */
        pageSelectConditionType:[{text:"PC",value:"0"},{text:"移动端",value:"1"},{text:"响应式",value:"2"}],
        /**
         * 配置开发工具中组件属性控件（页面选择：pageSelect）页面排序的检索条件
         * 如果为数组格式则是属于静态数据，格式：[{text:"创建时间正序",value:"cjsjzx"},...]
         * 为字符串格式则视为通过接口获取，返回格式为：
         * 返回结果示例：
         * {
         *    "code":"200",
         *    "message":"",
         *    "data":[{text:"创建时间正序",value:"cjsjzx"},...]
         * }
         */
        pageSelectConditionSort:[{text:"创建时间正序",value:"cjsjzx"},{text:"创建时间倒序",value:"cjsjdx"},{text:"优先级排序",value:"yxjpx"}],
        /**
         * 配置开发工具中组件属性控件（页面选择：pageSelect）页面分组的检索条件
         * 如果为数组格式则是属于静态数据，格式：[{text:"首页",value:"index"},...]
         * 为字符串格式则视为通过接口获取，返回格式为：
         * 返回结果示例：
         * {
         *    "code":"200",
         *    "message":"",
         *    "data":[{text:"首页",value:"index"},...]
         * }
         */
        pageSelectConditionGroup:"/ctrl/idm/console/fetchYMFZOptionList",
        /**
         * 配置开发工具中数据源类型的选项值
         * 如果为数组格式则是属于静态数据，格式：[{text:"接口API",value:"1"},...]
         * 为字符串格式则视为通过接口获取，返回格式为：
         * 返回结果示例：
         * {
         *    "code":"200",
         *    "message":"",
         *    "data":[{text:"接口API",value:"1"},...]
         * }
         */
        dataSourceConditionType:[{text:"接口API",value:"1"},{text:"数据模型",value:"6"},{text:"静态数据",value:"2"},{text:"json文件",value:"3"},{text:"sql语句",value:"4"},{text:"csv文件",value:"5"}],
        /**
         * 配置开发工具中数据源分组的选项值
         * 如果为数组格式则是属于静态数据，格式：[{text:"未分组",value:"-1"},...]
         * 为字符串格式则视为通过接口获取，返回格式为：
         * 返回结果示例：
         * {
         *    "code":"200",
         *    "message":"",
         *    "data":[{text:"未分组",value:"-1"},...]
         * }
         */
        dataSourceConditionGroup:"/ctrl/idm/console/fetchCommonOptionCodeList?codeFid=221020231236xTtQEZlqukQA0Z3dIMp",
         /**
         * 配置开发工具中数据源适配组件的选项值
         * 如果为数组格式则是属于静态数据，格式：[{text:"组件示例",value:"1"},...]
         * 为字符串格式则视为通过接口获取，返回格式为：
         * 返回结果示例：
         * {
         *    "code":"200",
         *    "message":"",
         *    "data":[{text:"组件示例",value:"1"},...]
         * }
         * 非分组的：/ctrl/idm/console/fetchAllModuleMarketList
         */
        dataSourceConditionModuleList:"/ctrl/idm/api/fetchComponentMarketData",
        /**
         * 配置开发工具中数据源所属产品标签的选项值
         * 如果为数组格式则是属于静态数据，格式：[{text:"门户管理",value:"p1101"},...]
         * 为字符串格式则视为通过接口获取，返回格式为：
         * 返回结果示例：
         * {
         *    "code":"200",
         *    "message":"",
         *    "data":[{text:"门户管理",value:"p1101"},...]
         * }
         * 默认值为：/ctrl/idm/console/fetchCommonOptionCodeList?codeFid=221018150019zKrByzp12esVB7nAiIT
         */
        dataSourceConditionProductList:"/ctrl/idm/console/fetchCommonOptionCodeList?codeFid=221018150019zKrByzp12esVB7nAiIT",
        /**
         * 配置开发工具中数据模型分组的选项值
         * 如果为数组格式则是属于静态数据，格式：[{text:"未分组",value:"-1"},...]
         * 为字符串格式则视为通过接口获取，返回格式为：
         * 返回结果示例：
         * {
         *    "code":"200",
         *    "message":"",
         *    "data":[{text:"未分组",value:"-1"},...]
         * }
         */
         dataModelConditionGroup:"/ctrl/idm/console/fetchCommonOptionCodeList?codeFid=2211101124250PGpoTKvOI9rrBXDNKo",
         /**
         * 配置开发工具中数据模型类型的选项值
         * 如果为数组格式则是属于静态数据，格式：[{text:"数据源建表",value:"1"},...]
         * 为字符串格式则视为通过接口获取，返回格式为：
         * 返回结果示例：
         * {
         *    "code":"200",
         *    "message":"",
         *    "data":[{text:"数据源建表",value:"1"},...]
         * }
         */
        dataModelConditionType:[{text:"数据源建表",value:"1"},{text:"SQL建表",value:"2"},{text:"excel上传",value:"3"},{text:"api数据",value:"4"}],
        
        /**
         * 获取数据源所属目录树结构数据
         * 返回结果：
         * {
         *    "code":"200",
         *    "message":"",
         *    "data":{
                "codeList": [
                    {
            *          "id": "221129152011u6M5NIlmdGWDs5vNWRR",
                        "pid": "1",
                        "name": "数据源",
                        "attrs": {
                            "directory": false
                        },
                        "itemIndex": 2,
                        "showName": "数据源",
                        "type": 0,
                        "open": null,
                        "children": [
            *              ...
                        ]
                    
                    }
            *       ...
                ]
         *    }
         * }
         * 或直接配置[{children:[]}]
         */
        dataSourceDirectoryTree:"ctrl/idm/code/getCodeTree?codeIds=221129152011u6M5NIlmdGWDs5vNWRR",
        /**
         * 设计器的图片地址，如果为空则显示默认的IDM的logo
         */
        logoImgSrc:"",
        /**
         * 设计器的标题名称
         */
        siteTitle:"IDM可视化设计器",
        /**
         * 模块元数据列表所需指定的参数名称，通过该参数值去获取模块中所有的元数据和属性中对应的流程节点数据
         */
        moduleMetaDataParamName:"moduleId"
    },
    //文档管理工具配置
    document:{
        /**
         * 代码包的文档相对路径
         * 比如，代码包地址为：idm/idm_modules/basic/1.0.0/
         * 那么，代码包的文档应该在这个代码包地址里面，例如：static/doc/
         * 文档文件名称固定为index.md
         */
        codepackageDocumentPath:"static/doc/",
        /**
         * 代码包内的组件的文档相对路径
         * 比如，代码包地址为：idm/idm_modules/basic/1.0.0/
         * 那么，代码包的文档应该在这个代码包地址里面，例如：static/doc/components/
         * 文档文件名称固定为组件的类名.md，例如按钮的文档名称为：IButton.md
         */
        moduleDocumentPath:"static/doc/components/",
        /**
         * 根据前端的配置保存md文件到对应的目录中
         * 接收以下参数：
         * mdPath:md对应要生成的文件地址
         * type:code代表未代码包的路径，module代表组件的文档路径
         * moduleClassName:组件的类名
         * mdContent:md文档的内容
         */
        saveMarkDownFileUrl:"/ctrl/idm/api/saveDocumentMdFile"
    },
    //应用程序综合配置
    applications:{
        /**
         * 作用于如果标题为空的时候会显示此处默认标题，支持使用表达式（IDM、window）
         */
        defaultTitle:"Idm preview default title",
        /**
         * 设计器和渲染引擎默认的浏览器ico图标，为空则使用默认的，渲染引擎会使用页面设置的覆盖
         */
        faviconIcoSrc:"",
        /**
         * 页面设置统一的默认登录页地址
         */
        defaultLoginPageUrl:"/ctrl/login",
        /**
         * 主题class名称的前缀
         */
        themeNamePrefix:"idm-theme-",
        /**
         * 组件控制中心的默认设置url
         */
        moduleControlCenterSettingUrl:"~/index.html#/preview/idm_control_setting_panel_001",
        /**
         * 应用程序是否启用项目编号模式的配置，也就是平台代码与组件代码分离的方式，默认为true，中途修改转换可能会造成程序读取异常，请在初始化的时候配置好
         */
        useProjectNoSetting:true,
        /**
         * 组件属性的存储所在的文件夹名称
         */
        moduleAttrFolderName:"attributes",
        /**
         * 组件属性中的字体列表
         */
        fontFamilyList:[
            {
                value:"arial, helvetica, 'microsoft yahei'",
                label:"Arial, Helvetica, 微软雅黑"
            },
            {
                value:"arial, helvetica, simhei",
                label:"Arial, Helvetica, 黑体"
            },
            {
                value:"'comic sans ms', 'microsoft yahei'",
                label:"Comic Sans MS, 微软雅黑"
            },
            {
                value:"'comic sans ms', simhei",
                label:"Comic Sans MS, 黑体"
            },
            {
                value:"impact, 'microsoft yahei'",
                label:"Impact, 微软雅黑"
            },
            {
                value:"impact, simhei",
                label:"Impact, 黑体"
            },
            {
                value:"'lucida sans unicode', 'microsoft yahei'",
                label:"Lucida Sans Unicode, 微软雅黑"
            },
            {
                value:"'lucida sans unicode', simhei",
                label:"Lucida Sans Unicode, 黑体"
            },
            {
                value: "AlibabaPuHuiTi-Regular",
                label: "AlibabaPuHuiTi-Regular"
            },
            {
                value: "PingFangSC-Regular",
                label: "PingFangSC-Regular"
            }
        ],
        /**
         * 默认引用的资源
         */
        commonRequireJsCss:[
            "/resource/js/public.js",
            // "/resource/js/dreamweb-core.js",
            "/websocket/webscoket.js"
        ],
        /**
         * 打开核心框架的资源加载动画
         */
        openIdmCoreLoadStyle:true,
        /**
         * 加载动画的颜色
         */
        idmCoreLoadColor:"#1890ff",
        /**
         * 渲染引擎默认加载颜色
         */
        defaultPreviewLoadColor:"#1890ff",
        /**
         * 页面配置中的微信SDK默认开启关闭状态。
         */
        defaultOpenWeixinJSSDK:true,
        /**
         * 页面配置中的下拉刷新默认开启关闭状态。
         */
         defaultOpenPulltorefresh:true,
         /**
          * http请求统一配置头部列表
          * 配置方式：
          * {
          *    name:"headerName",
          *    type:"constant：常量、cache：从缓存中读取(优先cookie、localStorage、sessionStorage)、cookie：从cookie读取、localStorage：从localStorage中读取、url:从url参数中读取、express：IDM的表达式，可以获取应用信息、用户信息、主题信息、IDM对象等等",
          *    express:"根据上面的类型填缓存KEY、表达式"
          * }
          */
         httpInCommonHeaderList:[],
         /**
          * 基本属性授权属性配置对象
          */
         basicAttributeAuthorizeConfig:{
            /**
             * 设置是否开启授权配置属性，如果开启了建议其他属性都要配置正确，否则在渲染的时候会进行比对权限的时候查找错误导致页面渲染有问题
             */
            openAuthorize:true,
            /**
             * 权限授权配置
             */
            privilege:{
                /**
                 * 设置是否开启
                 */
                open:true,
                /**
                 * 下拉选择的数据源地址，可携带参数
                 * 参数或地址可填写表达式
                 * 例如：
                 * /ctrl/idm/api/getPrivilegeList?userType=@[IDM.user.getCurrentUserInfo().userType]"
                 */
                dataSourceUrl:"/ctrl/idm/api/getPrivilegeList",
                /**
                 * 比对对象，这里为填写表达式，可使用IDM整个对象（包括应用信息、用户信息），也可使用页面接口查询的结果
                 * 使用IDM对象：IDM.user.getCurrentUserInfo()[比对内容的属性，例如：privilegeIds] 或 IDM.user.userObject[比对内容的属性，例如：privilegeIds]
                 * 或
                 * 使用页面接口结果集：结果集名称[比对内容的属性，例如：privilegeIds]
                 * 默认：IDM.user.getCurrentUserInfo().privilegeIds
                 */
                comparisonObject:"IDM.user.getCurrentUserInfo().privilegeIds",
                /**
                 * 分隔符，如果当前要比对的对象是多个，则需要进行拆分一个一个去比对，也就是多对多的比对，所以结果如果为字符串则需要配置上分隔符，如果结果为数组则不需要填写分隔符
                 */
                separator:",",
                /**
                 * 比对的授权结果中每项的哪个字段
                 */
                comparisonKey:"key"
            },
            /**
             * 角色授权配置
             */
            role:{
                /**
                 * 设置是否开启
                 */
                open:true,
                /**
                 * 下拉选择的数据源地址，可携带参数
                 * 参数或地址可填写表达式
                 * 例如：
                 * /ctrl/idm/api/getRoleList?userType=@[IDM.user.getCurrentUserInfo().userType]"
                 */
                dataSourceUrl:"/ctrl/idm/api/getRoleList",
                /**
                 * 比对对象，这里为填写表达式，可使用IDM整个对象（包括应用信息、用户信息），也可使用页面接口查询的结果
                 * 使用IDM对象：IDM.user.getCurrentUserInfo()[比对内容的属性，例如：roleIds] 或 IDM.user.userObject[比对内容的属性，例如：roleIds]
                 * 或
                 * 使用页面接口结果集：结果集名称[比对内容的属性，例如：roleIds]
                 * 默认：IDM.user.getCurrentUserInfo().roleIds
                 */
                comparisonObject:"IDM.user.getCurrentUserInfo().roleIds",
                /**
                 * 分隔符，如果当前要比对的对象是多个，则需要进行拆分一个一个去比对，也就是多对多的比对，所以结果如果为字符串则需要配置上分隔符，如果结果为数组则不需要填写分隔符
                 */
                separator:",",
                /**
                 * 比对的授权结果中每项的哪个字段
                 */
                comparisonKey:"key"
            },
            /**
             * 单位授权配置
             */
            dept:{
                /**
                 * 设置是否开启
                 */
                open:true,
                /**
                 * 下拉选择的数据源地址，可携带参数
                 * 参数或地址可填写表达式
                 * 例如：
                 * /ctrl/idm/api/getDeptList?userType=@[IDM.user.getCurrentUserInfo().userType]"
                 * 默认：
                 * /ctrl/idm/api/getDeptList?types=department,org&rootObject=2
                 */
                dataSourceUrl:"/ctrl/idm/api/getDeptList?types=department,org&rootObject=2",
                /**
                 * 比对对象，这里为填写表达式，可使用IDM整个对象（包括应用信息、用户信息），也可使用页面接口查询的结果
                 * 使用IDM对象：IDM.user.getCurrentUserInfo()[比对内容的属性，例如：userDepIds] 或 IDM.user.userObject[比对内容的属性，例如：userDepIds]
                 * 或
                 * 使用页面接口结果集：结果集名称[比对内容的属性，例如：userDepIds]
                 * 默认：IDM.user.getCurrentUserInfo().userDepIds
                 */
                comparisonObject:"IDM.user.getCurrentUserInfo().userDepIds",
                /**
                * 分隔符，如果当前要比对的对象是多个，则需要进行拆分一个一个去比对，也就是多对多的比对，所以结果如果为字符串则需要配置上分隔符，如果结果为数组则不需要填写分隔符
                */
               separator:"",
               /**
                * 比对的授权结果中每项的哪个字段
                */
               comparisonKey:"attrs.idValue"
            },
            /**
             * 人员授权配置
             */
            user:{
                /**
                 * 设置是否开启
                 */
                open:true,
                /**
                 * 下拉选择的数据源地址，可携带参数
                 * 参数或地址可填写表达式
                 * 例如：
                 * /ctrl/idm/api/getDeptList?userType=@[IDM.user.getCurrentUserInfo().userType]"
                 * 默认：
                 * /ctrl/idm/api/getDeptList?types=person&rootObject=2
                 */
                dataSourceUrl:"/ctrl/idm/api/getDeptList?types=person&rootObject=2",
                /**
                 * 比对对象，这里为填写表达式，可使用IDM整个对象（包括应用信息、用户信息），也可使用页面接口查询的结果
                 * 使用IDM对象：IDM.user.getCurrentUserInfo()[比对内容的属性，例如：userid] 或 IDM.user.userObject[比对内容的属性，例如：userid]
                 * 或
                 * 使用页面接口结果集：结果集名称[比对内容的属性，例如：userid]
                 * 默认：IDM.user.getCurrentUserInfo().userid
                 */
                comparisonObject:"IDM.user.getCurrentUserInfo().userid",
                /**
                 * 比对的授权结果中每项的哪个字段
                 */
                comparisonKey:"attrs.idValue"
            }
         },
         /**
          * http请求的超时时间，默认为0永不超时
          */
         httpTimeout:0,
         /**
          * 用户个性化配置
          */
         userCustomConfig:{
            /**
             * 用户个性化之文字比例获取字段，支持使用a.b.c的方式
             */
            fontSizeRatioRule:"fontSizeRatio"
         },
         /**
          * 页面动态头部信息meta设置
          * [{
                name:"",
                content:"",
                other
            }]
          */
         pageDynamicHeadMetaConfig:[],
         /**
          * 未登录的状态码，通过判断此状态码来去拦截所有接口未登录则去跳转到页面设置中设置了强制登录的跳转地址
          */
         noLoginStatusCode:30001
    },
    //websocket消息配置
    websocket:{
        /**
         * 用于设置调用初始化websocket方法名，websocket脚本可通过commonRequireJsCss引入，也可通过页面扩展开发。
         */
        websocketInitEventName:"initDreamSocketClient",
        /**
         * websocket打开后会调用IDM内置的打开方法，此处用于设置IDM内置的websocket打开后的处理方法的默认值（可在页面设置中修改）
         */
        websocketOpenEventName:"onWebSocketOpen",
        /**
         * websocket收到消息后会调用IDM内置的监听消息方法，此处用于设置IDM内置的websocket收到消息后的处理方法的默认值（可在页面设置中修改），收到消息后会给所有组件发送指定协议（websocket）的值
         */
        websocketMessageEventName:"onWebSocketMessage"
    },
    //微信功能配置
    weixin:{
        /**
         * 要引入的微信js-sdk
         */
        requireJsCss:[
            "~lib/jweixin-1.2.0.js"
        ],
        /**
         * 必填，需要使用的JS接口列表，所有JS接口列表见官方文档（https://developer.work.weixin.qq.com/document/path/90513）
         * 默认：'launch3rdApp', 'request3rdApp', 'onHistoryBack', 'hideAllNonBaseMenuItem', 'hideOptionMenu', 'openUrl', 'closeWindow'
         */
        jsApiList: ['launch3rdApp', 'request3rdApp', 'onHistoryBack', 'hideAllNonBaseMenuItem', 'hideOptionMenu', 'openUrl', 'closeWindow'],
        /**
         * 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
         */
        debug:false,
        /**
         * 签名获取接口地址
         * 默认：/tencentCustomize/getConfig，
         * 返回结果：
         * {
         *   code:"200",
         *   message:"",
         *   type:"success",
         *   data:{
         *      appId:"",
         *      timestamp:"",
         *      nonceStr:"",
         *      signature:"",
         *   }
         * }
         */
        signatureUrl:"/ctrl/tencentCustomize/getConfig"
    },
    /**
     * 会话保持功能
     * 此处专门为应用程序登录信息为session准备的（在需要登录信息永久保持的情况下才建议开启此功能）
     * 处理流程：
     * 1、用户密码登录或单点登录的时候同时后端通过jwt（用户信息+密钥）生成登录令牌并存储在前端（url参数、cookie、localStorage）
     * 2、IDM在请求获取用户信息接口后发现session掉了则会通过后端提供通过jwt重新进行登录的接口去登录，一旦发现登录成功则会二次去请求获取用户信息接口
     * 3、如果jwt登录也失效了则会执行原来的跳转登录地址
     */
    sessionKeep:{
        /**
         * 前端缓存后端生成的密钥名称
         * 1、localStorage
         * 2、cookie
         * 3、url参数
         */
        cacheKeyName:"idm_sessionkeep_token",
        /**
         * 页面配置中的会话保持默认开启状态，true：默认开启，false：默认关闭
         */
        defaultOpenSessionKeep:false,
        /**
         * 重新登录地址
         * 默认登录地址：/silentRelogin
         * 请求方式：post
         * 请求参数：
         * [cacheKeyName]:当前配置的前端缓存的key名称
         */
        defaultSilentReLoginUrl:"/silentRelogin"
    },
    //表单相关功能控制
    form:{
        //初始化加载表单数据接口默认地址，默认：/ctrl/idm/form/getFormData
        initFormDataDefaultApi:"/ctrl/idm/form/getFormData",
        //加载表单接口的默认请求类型，默认为get，可为post和get
        initApiDefaultRequestType:"get",
        //加载表单接口的默认参数类型，默认为空，可为application/json;charset=UTF-8 或 multipart/form-data
        initApiDefaultContentType:"",
        //加载表单接口的参数名称指定
        initApiParamNameSetting:{
            //表单参数数据的url参数中的表单参数名称，且同时是指定了给加载表单接口请求后端的表单参数名称，例如：url中参数指定为__formData，同理给后端的参数名称也为__formData
            formData:"__formData",
            //将会用页面ID，即从IDM.broadcast.pageModule.id获取到的值传递给后端接口，此处是指定此值传给后端的名称
            formId:"formId"
        },
        /**
         * 加载表单接口的默认请求扩展参数，默认为空数组
         * 格式为：[{paramKey:"",paramVal:""}]
         * 其中他们的值都支持IDM表达式填写，例如：
         * [{
         *  paramKey:"@[url('abc')]",
         *  paramVal:"@[IDM.user.getCurrentUserInfo().userid]"
         * }]
         */
        initApiDefaultExtendParam:[],
        //加载接口返回的结果与表单所需要对应的值的表达式，通俗来讲就是下面对象所需要的数据从接口返回的结果那个属性中取
        initResultFieldExpress:{
            //表单的基本参数和url传递过来的参数内容
            queryObject:"data.QueryObject",
            //该模块所有元数据配置信息
            metaConfig:"data.MetaConfig",
            //页面上所有组件已绑定元数据的所需要的数据源
            componentData:"data.ComponentData",
            //表单填写的数据
            formData:"data.FormData.json",
            //依据表单&节点权限设置信息
            roleData:"data.RoleData.flowMetas"
        },
        //保存表单数据接口默认地址，默认：/ctrl/idm/form/saveFormData
        saveFormDataDefaultApi:"/ctrl/idm/form/saveFormData",
        //保存表单接口的默认参数类型，默认为空，可为application/json;charset=UTF-8 或 multipart/form-data
        saveApiDefaultContentType:"",
        /**
         * 保存表单接口的默认请求扩展参数，默认为空数组
         * 格式为：[{paramKey:"",paramVal:""}]
         * 其中他们的值都支持IDM表达式填写，例如：
         * [{
         *  paramKey:"@[url('abc')]",
         *  paramVal:"@[IDM.user.getCurrentUserInfo().userid]"
         * }]
         */
         saveApiDefaultExtendParam:[],
    }
}